export let configMode = localStorage.getItem("configMode");

localStorage.removeItem("configMode");

if (!configMode || !["LOCAL", "DEV", "PROD"].includes(configMode)) {
  configMode = import.meta.env.VITE_CONFIG_MODE;
}

console.log("Config mode:", configMode);

export const config = new Proxy<{
  VITE_MC_APP_NAME: string;
  [key: string]: string;
}>(
  {},
  {
    get: (_, key) => {
      if (key === "mode") {
        return configMode;
      }

      const modeKey =
        typeof key === "string"
          ? key.replace(`VITE_`, `VITE_${configMode}_`)
          : key;

      return import.meta.env[modeKey] ?? import.meta.env[key];
    },
    set: (_, prop, value) => {
      if (
        value &&
        prop === "mode" &&
        ["LOCAL", "DEV", "PROD"].includes(value) &&
        value !== configMode
      ) {
        configMode = value;
        console.warn(
          "Change detected on CONFIG.mode, the page will be refreshed..."
        );
        localStorage.setItem("configMode", value);
        window.location.reload();

        return true;
      }

      return false;
    },
  }
);
